import { useEffect, useState } from 'react';
import { debounce } from '../../../../../_helpers/performanceUtils';

export function useWindowHeight() {
	const [windowHeight, setWindowHeight] = useState<number>();
	useEffect(() => {
		const updateHeight = () => setWindowHeight(window.innerHeight);
		const debouncedUpdateHeight = debounce(updateHeight, 300);
		window.addEventListener('resize', debouncedUpdateHeight);
		updateHeight();
		return () => window.removeEventListener('resize', debouncedUpdateHeight);
	}, []);

	return windowHeight;
}
